import { SUPPORTED_LANGUAGES } from "@repo/shared";

/** When false, language dropdowns are hidden and English is always used. */
export const isLanguageSelectionEnabled = true;

export const DEFAULT_LANGUAGE = SUPPORTED_LANGUAGES.EN;
